import React, { useRef } from "react"
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Text,
  Heading,
  Image,
} from "@chakra-ui/react"

import { GatsbyImage } from "gatsby-plugin-image"
import MethodologyContent from "./methodology-content"

const styles = {
  root: { width: "100%", fontFamily: "Inter var, sans-serif" },
  container: { my: "60px", mx: { base: "16px", md: "60px", lg: "60px" } },
  heading: {
    fontSize: { base: "24px", md: "24px", lg: "32px" },
    fontWeight: 700,
    lineHeight: { base: "32px", md: "32px", lg: "40px" },
    color: "#2D3748",
  },
  "sub-heading": {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "21px",
    color: "#2D3748",
  },
  hero: { mt: "20px", width: "130px" },
}

const MethodologyDrawer = ({ onClose, isOpen, imagePath }) => {
  const initialRef = useRef()

  return (
    <Box sx={styles.root}>
      <Drawer
        placement="right"
        onClose={onClose}
        isOpen={isOpen}
        size="xl"
        initialFocusRef={initialRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerBody p="0px">
            <Box sx={styles.container}>
              <Box ref={initialRef} tabIndex={-1} />

              <Heading sx={styles.heading}>Research Methodology</Heading>

              <Box mt="32px">
                <Text sx={styles["sub-heading"]}>
                  Healthcare Research All-Stars
                </Text>
                <Box sx={styles.hero}>
                  <Image
                    as={GatsbyImage}
                    alt="Healthcare Research All-Stars Logo"
                    image={imagePath?.node?.childImageSharp?.gatsbyImageData}
                    w="130px"
                  />
                </Box>
              </Box>

              <Box mt="32px">
                <MethodologyContent isDrawerContent />
              </Box>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  )
}

export default MethodologyDrawer
